define([], () => ({
  REQUEST_DISPLAY_RULES: 'REQUEST_DISPLAY_RULES',
  RECEIVE_DISPLAY_RULES: 'RECEIVE_DISPLAY_RULES',
  ERROR_DISPLAY_RULES: 'ERROR_DISPLAY_RULES',
  UPDATE_DISPLAY_RULE_GROUP: 'UPDATE_DISPLAY_RULE_GROUP',
  UPDATE_DISPLAY_RULE_SETTING: 'UPDATE_DISPLAY_RULE_SETTING',
  SAVE_DISPLAY_RULES: 'SAVE_DISPLAY_RULES',
  DELETE_DISPLAY_RULE_GROUP: 'DELETE_DISPLAY_RULE_GROUP',
  DELETE_DISPLAY_RULE: 'DELETE_DISPLAY_RULE',

  RECEIVE_DISPLAY_RULE_SETS: 'RECEIVE_DISPLAY_RULE_SETS',
  RECEIVE_DISPLAY_RULE_SET: 'RECEIVE_DISPLAY_RULE_SET',
  DELETE_DISPLAY_RULE_SET: 'DELETE_DISPLAY_RULE_SET',
}));
